import './InputAuthCode.scss';
import { Input } from '@components/Component/Field/Input/Input.js';
import { createElement, isCtrlKey } from '@components/Utility/index.js';
/**
 * Class `InputPhone` represents an Input for displaying phone fields in Q360.
 */
export class InputAuthCode extends Input {
    constructor() {
        super(...arguments);
        this.componentName = 'InputAuthCode';
        this._inputMode = 'numeric';
        this._maxLength = 6; // we need a default for this property
    }
    draw() {
        super.draw();
        const digitContainer = this.rootElement.querySelector('.auth-code-container');
        if (digitContainer) {
            this.registerEvent('click', digitContainer, () => this.focus());
        }
        if (this.inputElement) {
            this.registerEvent('input', this.inputElement, this.inputChanged.bind(this));
        }
    }
    handlePaste(event) {
        const pastedData = event.clipboardData?.getData('text') || '';
        console.log('we have something to paste', pastedData, event);
        // force conversion to number to test against. Only numbers are permitted to paste
        const numericValue = +pastedData;
        if (isNaN(numericValue)) {
            this.invalidInput(true);
        }
        else {
            const trimLength = this.fieldLength - (this.inputValue?.length || 0);
            const trimmedData = pastedData.substring(0, trimLength);
            for (const char of trimmedData) {
                const inputEvent = new InputEvent('input', {
                    bubbles: true,
                    cancelable: true,
                    data: char,
                    inputType: 'insertText'
                });
                if (this.inputElement) {
                    this.inputElement.value += char;
                    this.inputElement.dispatchEvent(inputEvent);
                }
            }
        }
        event.preventDefault();
    }
    validateKeyPress(event) {
        // force only numeric input 0-9
        const isDigit = /^[0-9]$/.test(event.key);
        const validKeys = ['Backspace', 'Enter', 'Control'].includes(event.key); // including control to prevent an invalid key press when ctrl is pressed alone
        const validCtrlKeys = isCtrlKey(event) && event.key === 'v';
        let validKeyPress = isDigit || validKeys || validCtrlKeys;
        console.log('validate auth key: ', event.key, validKeyPress);
        if (validKeyPress) {
            validKeyPress = super.validateKeyPress(event);
        }
        if (!validKeyPress) {
            this.invalidInput();
        }
        return validKeyPress;
    }
    inputChanged(event) {
        const key = event.data;
        const currentLength = key ? (this.inputValue || '').length : (this.inputValue || '').length + 1;
        const currentNextElem = this.rootElement.querySelector('.auth-code-digit.next-digit');
        if (currentNextElem) {
            if (key) {
                currentNextElem.classList.add('filled');
                currentNextElem.innerHTML = key;
            }
            else {
                // backspace pressed
                const previousElem = (currentLength === this.fieldLength ? currentNextElem : currentNextElem.previousSibling);
                previousElem.innerText = '';
                previousElem.classList.remove('filled');
            }
            this.userChange((this.inputValue || ''));
            this.setNextDigit();
        }
    }
    handleBlur(event) {
        super.handleBlur(event);
        this.setNextDigit(true);
    }
    handleFocus(event) {
        super.handleFocus(event);
        this.setNextDigit();
        console.log('handle focus');
    }
    invalidInput(allUnfilled = false) {
        if (allUnfilled) {
            const unfilledElements = this.rootElement.querySelectorAll('.auth-code-digit:not(.filled)');
            if (unfilledElements.length) {
                unfilledElements.forEach(el => {
                    el.classList.add('invalid');
                    el.addEventListener('animationend', () => {
                        el.classList.remove('invalid');
                    }, { once: true });
                });
            }
        }
        else {
            const currentNextElem = this.rootElement.querySelector('.auth-code-digit.next-digit');
            if (currentNextElem) {
                currentNextElem.classList.add('invalid');
                currentNextElem.addEventListener('animationend', () => {
                    currentNextElem.classList.remove('invalid');
                }, { once: true });
            }
        }
    }
    inputTemplate() {
        const container = createElement('div', ['auth-code-container']);
        for (let i = 0; i < this.fieldLength; i++) {
            const digit = createElement('div', ['auth-code-digit'], { 'data-index': i.toString() });
            container.appendChild(digit);
        }
        this.inputElement = createElement('input', ['hidden-auth']);
        this.rootElement?.appendChild(container);
        this.fieldInputWrapper?.appendChild(this.inputElement);
    }
    clearInput() {
        const digits = this.rootElement.querySelectorAll('.auth-code-digit');
        this.record?.set(this.columnName, '');
        digits.forEach((el) => {
            el.innerHTML = '';
            el.classList.remove('filled');
            el.classList.remove('next-digit');
        });
    }
    setNextDigit(unsetOnly = false) {
        const currentIndex = (this.inputValue || '').length;
        const currentNextElem = this.rootElement.querySelector('.auth-code-digit.next-digit');
        if (currentNextElem && currentIndex !== this.fieldLength) {
            currentNextElem.classList.remove('next-digit');
        }
        if (!unsetOnly) {
            const nextDigit = this.rootElement.querySelector(`.auth-code-digit[data-index="${currentIndex}"]`);
            if (nextDigit) {
                nextDigit.classList.add('next-digit');
            }
        }
    }
}
InputAuthCode.VERSION = '$Revision: 112885 $';
